import { FilePlus02 } from "@untitledui/icons";
import { useState } from "react";
import { Button } from "@/components/base/buttons/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { TagLibraryEditor } from "./tag-library-editor";
import { useTagLibraryEditor } from "./use-tag-library-editor";

export const TagLibraryModal = ({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) => {
  const editor = useTagLibraryEditor({ active: open });
  const [confirmDiscard, setConfirmDiscard] = useState(false);

  const handleSave = async () => {
    const ok = await editor.handleSave();
    if (ok) onOpenChange(false);
  };

  // Intercept close attempts to guard unsaved changes.
  const handleOpenChange = (next: boolean) => {
    if (!next && editor.isDirty) {
      setConfirmDiscard(true);
      return;
    }
    onOpenChange(next);
  };

  return (
    <>
      <Dialog open={open} onOpenChange={handleOpenChange}>
        <DialogContent className="flex max-h-[85vh] flex-col sm:max-w-[72rem]">
          <DialogHeader>
            <DialogTitle data-testid="tag-library-title">Tags</DialogTitle>
            <DialogDescription>Manage your tag library</DialogDescription>
          </DialogHeader>

          <TagLibraryEditor editor={editor} />

          <DialogFooter>
            <Button color="secondary" onClick={() => handleOpenChange(false)}>
              Cancel
            </Button>
            <Button color="primary" iconLeading={FilePlus02} isLoading={editor.isPending} onClick={handleSave}>
              Save
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Unsaved-changes guard */}
      <Dialog open={confirmDiscard} onOpenChange={setConfirmDiscard}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Discard changes?</DialogTitle>
            <DialogDescription>You have unsaved changes. Closing now will discard them.</DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button color="secondary" size="sm" onClick={() => setConfirmDiscard(false)}>
              Keep editing
            </Button>
            <Button
              color="primary-destructive"
              size="sm"
              onClick={() => {
                setConfirmDiscard(false);
                onOpenChange(false);
              }}
            >
              Discard
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
